import axios from 'axios';
import errorMessage from 'Store/actions/errorMessage';

import {
  GET_AUTHORS_LIST_REQUEST,
  GET_AUTHORS_LIST_SUCCESS,
  GET_AUTHORS_LIST_FAILURE,
  GET_AUTHORS_HEADERS_REQUEST,
  GET_AUTHORS_HEADERS_SUCCESS,
  GET_AUTHORS_HEADERS_FAILURE,
  GET_AUTHORS_FILTER_REQUEST,
  GET_AUTHORS_FILTER_SUCCESS,
  GET_AUTHORS_FILTER__FAILURE,
  GET_AUTHOR_DETAIL_REQUEST,
  GET_AUTHOR_DETAIL_SUCCESS,
  GET_AUTHOR_DETAIL_FAILURE,
  GET_AUTHOR_LAST_COMMENTS_STATUS_REQUEST,
  GET_AUTHOR_LAST_COMMENTS_STATUS_SUCCESS,
  GET_AUTHOR_LAST_COMMENTS_STATUS_FAILURE,
  GET_AUTHOR_RESET
} from 'Store/constants';
import ProjectConfig from 'ProjectConfig';
import { authorDetailRedirection } from 'Utils/convertTurkishCharacters';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getAuthorsList = filterObj => async (dispatch, getState) => {
  const isAuth = getState().auth.isAuthenticated;

  try {
    dispatch({
      type: GET_AUTHORS_LIST_REQUEST
    });
    const eventType = filterObj.tabName;
    let res;
    if (filterObj.filter?.length > 0 ) {
      const reqObj = {
        authorIds: filterObj.filter
      };
      // res = await axios.post(`${API_GATEWAY}/v1/authors/all?sportType=${eventType}`, reqObj);
      res = await axios.post(`${API_GATEWAY}/v2/authors${!isAuth ? '/public' : ''}/all?sportType=${eventType}`, reqObj);

    } else {
      // res = await axios.post(`${API_GATEWAY}/v1/authors/all?sportType=${eventType}`);
      res = await axios.post(`${API_GATEWAY}/v2/authors${!isAuth ? '/public' : ''}/all?sportType=${eventType}`);
    }


    dispatch({
      type: GET_AUTHORS_LIST_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: GET_AUTHORS_LIST_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getAuthorsHeaders = () => async dispatch => {
  try {
    dispatch({
      type: GET_AUTHORS_HEADERS_REQUEST
    });
  
    const res = await axios.get(`${API_GATEWAY}/v1/authors/header`);
  
    dispatch({
      type: GET_AUTHORS_HEADERS_SUCCESS,
      payload: res.data
    });
  
  } catch (e) {
    dispatch({
      type: GET_AUTHORS_HEADERS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getAuthorsFilter = () => async dispatch => {
  try {
    dispatch({
      type: GET_AUTHORS_FILTER_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/v1/authors/active`);
  
    let modifedList = { items: [] };
    modifedList.items = res.data?.items?.map(element => {
      return {
        ...element,
        url: authorDetailRedirection(element)
      };
    });

    dispatch({
      type: GET_AUTHORS_FILTER_SUCCESS,
      payload: modifedList
    });
  
  } catch (e) {
    dispatch({
      type: GET_AUTHORS_FILTER__FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getAuthorsDetail = (authorId, page = 0, size = 20 ) => async dispatch => {
  try {
    dispatch({
      type: GET_AUTHOR_DETAIL_REQUEST
    });
    const requestBody = {
      authorId: authorId,
      page: page,
      size: size
    };

    // const res = await axios.get(`${API_GATEWAY}/v1/authors/detail/${ authorId }`);
    const res = await axios.post(`${API_GATEWAY}/v2/authors/public/detail`, requestBody);
    dispatch({
      type: GET_AUTHOR_DETAIL_SUCCESS,
      payload: res.data,
      page: page
    });
  
  } catch (e) {
    dispatch({
      type: GET_AUTHOR_DETAIL_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getAuthorsProfDetail = (authorId, page = 0, size = 20 ) => async dispatch => {
  try {
    dispatch({
      type: GET_AUTHOR_DETAIL_REQUEST
    });

    const requestBody = {
      authorId: authorId,
      page: page,
      size: size
    };

    // const res = await axios.get(`${API_GATEWAY}/v1/authors/detail/${ authorId }`);
    const res = await axios.post(`${API_GATEWAY}/v2/authors/prof/detail`, requestBody);

    dispatch({
      type: GET_AUTHOR_DETAIL_SUCCESS,
      payload: res.data,
      page: page
    });

  } catch (e) {
    dispatch({
      type: GET_AUTHOR_DETAIL_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getLastCommentsStatus = authorId => async dispatch => {
  try {
    dispatch({
      type: GET_AUTHOR_LAST_COMMENTS_STATUS_REQUEST
    });
  
    const res = await axios.get(`${API_GATEWAY}/v1/authors/last-win-lost?authorId=${ authorId }`);
  
    dispatch({
      type: GET_AUTHOR_LAST_COMMENTS_STATUS_SUCCESS,
      payload: res.data
    });
  
  } catch (e) {
    dispatch({
      type: GET_AUTHOR_LAST_COMMENTS_STATUS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const resetAuthors = () => async dispatch => {
  dispatch({
    type: GET_AUTHOR_RESET
  });
};
